module.exports = __webpack_public_path__ + "static/media/security.1ca9166f.svg";